import { generateTypes } from '../utils/HttpReducerHelper';

export const caseDetail = generateTypes('CASE', 'DETAIL');
export const casesList = generateTypes('CASES', 'LIST');
export const removeIntegration = generateTypes('INTEGRATION', 'REMOVE');
export const cancelCase = generateTypes('CASE', 'CANCEL_CASE');
export const deleteCase = generateTypes('CASE', 'DELETE_CASE');
export const snapshot = generateTypes('CASE', 'SNAPSHOT');
export const deleteBusinessProfile = generateTypes('CASE', 'DELETE_BUSINESS_PROFILE');
export const OPEN_CANCEL_CASE_MODAL = 'platfi-ui-app/CASE/OPEN_CANCEL_CASE_MODAL';
export const CLOSE_CANCEL_CASE_MODAL = 'platfi-ui-app/CASE/CLOSE_CANCEL_CASE_MODAL';
export const OPEN_DELETE_BUSINESS_PROFILE_MODAL =
  'platfi-ui-app/CASE/OPEN_DELETE_BUSINESS_PROFILE_MODAL';
export const CLOSE_DELETE_BUSINESS_PROFILE_MODAL =
  'platfi-ui-app/CASE/CLOSE_DELETE_BUSINESS_PROFILE_MODAL';
export const SSE_UPDATE_SNAPSHOT_PROFILE_GENERATION_PROGRESS = '@@SSE/entity/ledger/profile/update';
